export const timePanelHeaderText = "Pm7$ne";
export const meetNowHeaderText = "phH_L";
export const groupsPanelHeaderText = "Wxxprc";
export const notifNewItemsFmt = "LKVhuc";
export const updateAvailableHeaderText = "GxX7Ud";
export const applyingUpdatesHeaderText = "Art$Ed";
export default {timePanelHeaderText,meetNowHeaderText,groupsPanelHeaderText,notifNewItemsFmt,updateAvailableHeaderText,applyingUpdatesHeaderText};